const translation = {
	error: {
		required: "این قسمت ضروری است",
		date: "تاریخ نا معتبر است",
		password: "رمز عبور باید شامل یک حرف بزرگ، یک حرف کوچک و یک عدد باشد",
		SSN: "کد ملی صحیح وارد کنید",
		phoneNumber: "شماره موبایل صحیح وارد کنید",
		email: "ایمیل وارد کنید",
		number: "عدد وارد کنید",
		time: "HH:MM وارد کنید",
		percentage: "عددی بین صفر تا ۱۰۰ وارد کنید",
		integer: "عدد صحیح وارد کنید",
		telephoneSabet: "شماره ثابت را به شکل درست وارد کنید.",
		passwordRepeat: "گذرواژه یکی نیست",
		minCharacterCountStart: "تعداد کاراکتر ها باید بیشتر از",
		minCharacterCountEnd: "باشد",
		isPersian: "متن فارسی قابل قبول نیست.",
		postalCode: "کد پستی اشتباه است.",
	},
	notify: {
		success: {
			message: "عملیات با موفقیت انجام شد",
			closeAction: "بستن",
			caption: "موفقیت",
		},
		error: {
			message: "عملیات با خطا مواجه شد",
			closeAction: "بستن",
			caption: "خطا",
		},
		warning: {
			message: "عملیات با هشدار مواجه شد",
			closeAction: "بستن",
			caption: "هشداز",
		},
	},
	confirm: {
		title: "آیا از این عملیات اطمینان دارید ؟",
		message: "درصورت اطمینان از عملیات خود، بر روی دکمه قبول، کلیک کنید",
	},
	api: {
		connectionError: "خطا در ارتباط با سرور",
		serverError: "خطا در پردازش سرور",
	},
	select: {
		selectedLabel: "آیتم انتخاب شده است",
		noDataMessage: "داده ای برای نمایش وجود ندارد !",
	},
}

function t(key: string) {
	let object: Record<string, any> | string = translation
	const splitedKey = key.split(".")

	for (const item of splitedKey) {
		if (typeof object == "object") {
			object = object[item]
		}
		else {
			object = ""
			break
		}
	}

	return object.toString()
}

export function useTranslation() {
	return {
		t,
	}
}
